module.exports = "<section class=\"tab-container\" ng-if=\"active\" ng-transclude></section>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/tab/tab.html
// module id = 18
// module chunks = 0 1